import ApiSection from "../../Pages/ApiPage/ApiSection";
import ApiViewer from "../../Pages/ApiPage/ApiViewer";
import Application from "../../Pages/Application/Application";
import AppSettingsPage from "../../Pages/Application/ApplicationSettingsPage";
import ApplicationBlockSection from "../../Pages/ApplicationBlock/ApplicationBlockSection";
import ApplicationBlockViewer from "../../Pages/ApplicationBlock/ApplicationBlockViewer";
// import AppUserSection from "../../Pages/AppUser/AppUserSection";
import AppUserSection from "../../Pages/AppUser New/AppUserSection";
// import CommunityUserSection from "../../Pages/CommunityUser/CommunityUserSection";
// import CommunityUserSection from "../../Pages/CommunityUser New/CommunityUserSection";
import CronSection from "../../Pages/CRON/CronSection";
import CronViewer from "../../Pages/CRON/CronViewer";
import DBConnectors from "../../Pages/DBConnector/DBConnectors";
// import EntityCenterViewer from "../../Pages/Entity/EntityCenterViewer";
// import EntitySection from "../../Pages/Entity/EntitySection";
import FileRepoSection from "../../Pages/FileRepo/FileRepoSection";
import Form from "../../Pages/Form/Form";
import ImageRepoSection from "../../Pages/ImageRepo/ImageRepoSection";
import JobsSection from "../../Pages/Jobs/JobSection";
import LockSection from "../../Pages/Lock/LockSection";
import PositionFormPlayground from "../../Pages/PositionForm/PositionFormPlayground";
import PublicScreenSection from "../../Pages/PublicScreen/PublicScreenSection";
import PublicScreenViewer from "../../Pages/PublicScreen/PublicScreenViewer";
import RdbmsForm from "../../Pages/RdbmsForm/RdbmsForm";
import RdbmsFormSection from "../../Pages/RdbmsForm/RdbmsFormSection";
import Schema from "../../Pages/RdbmsSchema/Schema";
import ScreenRenderer from "../../Pages/Screen/ScreenRenderer";
import ScreenSection from "../../Pages/Screen/ScreenSection";
import StateMachineRenderer from "../../Pages/StateMachine/StateMachineRenderer";
import StateMachineSection from "../../Pages/StateMachine/StateMachineSection";
import StatemachineAI from "../../Pages/StatemachineAI/StatemachineAI";
import SqlTemplateCenterViewer from "../../Pages/Template/SqlTemplates/SqlTemplateCenterViewer";
import SqlTemplateSection from "../../Pages/Template/SqlTemplates/SqlTemplateSection";
import TemplateSection from "../../Pages/Template/TemplateSection";
import VariableSection from "../../Pages/Variables/VariableSection";
import BPMNViewer from "../../Pages/Workflow/BPMNViewer";
import WorkflowSection from "../../Pages/Workflow/WorkflowSection";
import ConnectorSection from "../../Pages/Connectors/ConnectorSection";
import ConnectorRenderer from "../../Pages/Connectors/ConnectorRenderer";
import TemplateCenterViewer from "../../Pages/Template/TemplateCenterViewer";
import EntitySection from "../../Pages/Entity New/EntitySection";
import EntityCenterViewer from "../../Pages/Entity New/EntityCenterViewer";
import React from "react";
import StateRenderer from "../../Pages/StateMachine/States/StateRenderer";
import ActivityRenderer from "../../Pages/StateMachine/Activity/ActivityRenderer";
import CustomFunction from "../../Pages/Form/CustomFunctions/CustomFunction";
import SubFormSection from "../../Pages/Form/SubForm/SubFormSection";
import SMFormSection from "../../Pages/Form/SMForm/SMFormSection";

export const applicationRoutes = [
  {
    index: true,
    element: <Application />
  },
  {
    path: ":appId/screen",
    element: <ScreenSection />,
    children: [
      {
        path: ":screenId",
        element: <ScreenRenderer />
      }
    ]
  },
  {
    path: ":appId/settings",
    element: <AppSettingsPage />
  },
  {
    path: ":appId/entity",
    // element: <EntitySection />,
    element: <EntitySection />,
    children: [
      {
        path: ":entityId",
        // element: <EntityCenterViewer />
        element: <EntityCenterViewer />
      }
    ]
  },
  {
    path: ":appId/statemachine",
    element: <StateMachineSection />,
    children: [
      {
        path: ":smId",
        element: <StateMachineRenderer />
      },
      {
        path: ":smId/activity/:activityId",
        element: <ActivityRenderer />
      },
      {
        path: ":smId/state/:stateId",
        element: <StateRenderer />
      }
    ]
  },
  {
    path: ":appId/statemachine/:smId/ai",
    element: <StatemachineAI />
  },
  {
    path: ":appId/applicationblock",
    element: <ApplicationBlockSection />,
    children: [
      {
        path: ":blockId",
        element: <ApplicationBlockViewer />
      }
    ]
  },
  {
    path: ":appId/workflow",
    element: <WorkflowSection />,
    children: [
      {
        path: ":workflowId",
        element: <BPMNViewer />
      }
    ]
  },
  {
    path: ":appId/template",
    element: <TemplateSection />,
    children: [
      {
        path: ":templateId",
        element: <TemplateCenterViewer />
      }
    ]
  },
  {
    path: ":appId/sqltemplate",
    element: <SqlTemplateSection />,
    children: [
      {
        path: ":sqlTemplateId",
        element: <SqlTemplateCenterViewer />
      }
    ]
  },
  {
    path: ":appId/smform",
    element: <Form />,
    children: [
      {
        path: ":smId/form/:formId",
        element: <SMFormSection />
      },
      {
        path: ":smId/form/:formId/advancededit",
        element: <PositionFormPlayground />
      },
      {
        path: "customfunction/:functionId",
        element: <CustomFunction />
      },
      {
        path: "subform/:subformId",
        element: <SubFormSection />
      }
    ]
  },
  {
    path: ":appId/connectors",
    element: <ConnectorSection />,
    children: [
      {
        path: ":connectorId",
        element: <ConnectorRenderer />
      }
    ]
  },
  {
    path: ":appId/jobs",
    element: <JobsSection />
  },
  {
    path: ":appId/cron",
    element: <CronSection />,
    children: [
      {
        path: ":cronId",
        element: <CronViewer />
      }
    ]
  },
  {
    path: ":appId/appuser",
    element: <AppUserSection />
  },
  // {
  //   path: ":appId/communityuser",
  //   element: <CommunityUserSection />
  // },
  {
    path: ":appId/filerepo",
    element: <FileRepoSection />
  },
  {
    path: ":appId/imagerepo",
    element: <ImageRepoSection />
  },
  {
    path: ":appId/variables",
    element: <VariableSection />
  },
  {
    path: ":appId/lock",
    element: <LockSection />
  },
  {
    path: ":appId/api",
    element: <ApiSection />,
    children: [
      {
        path: ":apiId",
        element: <ApiViewer />
      }
    ]
  },
  {
    path: ":appId/publicaccess",
    element: <PublicScreenSection />,
    children: [
      {
        path: ":publicId",
        element: <PublicScreenViewer />
      }
    ]
  },
  {
    path: ":appId/rdbmsschema",
    element: <Schema />
  },
  {
    path: ":appId/dbconnectors",
    element: <DBConnectors />
  },
  {
    path: ":appId/rdbmsform",
    element: <RdbmsForm />,
    children: [
      {
        path: ":rdbmsFormId",
        // element: <PositionFormPlayground />
        element: <RdbmsFormSection />
      }
    ]
  }
];
